export const KEEP_SIGNED_IN = 'keepSignedIn' as const
export const REQUESTING_SHARED_SESSION = 'requestingSharedSession' as const
export const SESSION_SHARING = 'sessionSharing' as const
